import React from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { useNavigate } from "react-router-dom";
import { useDeletePublisherGame, usePublisherAndContacts } from "@seabrookstudios/pitch2table";
import { PublisherLogo } from "../../publisher/PublisherLogo";
import { FollowUp } from "./FollowUp";
import { Path } from "../../Path";
import { PublisherBannerIcon } from "../../publishers/ListItem";
import { PublisherTimezoneWarning } from "../PublisherTimezoneWarning.js";
import { PublisherAutoRejectWarning } from "./PublisherAutoRejectWarning";
import { useGameIdFromRoute, usePublisherIdFromRoute } from "../WithGameIdFromRoute";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").DesignerPublisherGameView} props.publisherGame
 */
export const PublisherInterestProfileCard = ({ publisherGame }) => {
  const gameId = useGameIdFromRoute();
  const publisherId = usePublisherIdFromRoute();
  const { data: publisherAndContacts = [] } = usePublisherAndContacts(publisherId);
  const [publisher] = publisherAndContacts;
  const navigate = useNavigate();
  const deletePublisherGame = useDeletePublisherGame(gameId, publisherId, publisherGame.id);

  const removeShortlistedPublisher = async () => {
    await deletePublisherGame.mutateAsync();
    navigate(Path.game(gameId).publishers());
  };

  return (
    <Card elevation={1} square={false}>
      <CardContent>
        <PublisherLogo url={publisherGame.logoUrl} name={publisherGame.publisherName} />
        <CardHeader title={publisherGame.publisherName} />
        <PublisherAutoRejectWarning publisherGame={publisherGame} publisher={publisher} />
        {publisher && <PublisherTimezoneWarning timezone={publisher.timezone} />}
        <FollowUp publisherGame={publisherGame} />
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          onClick={() => navigate(Path.publisher(publisherId).link())}
          endIcon={publisher ? <PublisherBannerIcon publisher={publisher} /> : null}
        >
          View Profile
        </Button>
        {publisherGame.status === "ShortListed" && (
          <Button variant="outlined" color="error" onClick={removeShortlistedPublisher}>
            Unlist
          </Button>
        )}
      </CardActions>
    </Card>
  );
};
